module.exports = __webpack_public_path__ + "img/passe-a-laction.973ce2f6.png";